import React from "react";
import OtpInput from "react-otp-input";

const OTP = ({ value, handleChange, inputStyle }) => {
  return (
    <div className="w-full flex justify-center mt-10 sm:mt-7 lg:mt-[7%]">
      <OtpInput
        value={value}
        onChange={handleChange}
        numInputs={6}
        renderInput={(props, index) => (
          <>
            <input
              {...props}
              type="password"
              inputMode="numeric"
              pattern="[0-9]*"
              style={{ ...(props?.style||{}), color: "#000000", fontSize: 8, lineHeight: "24px", paddingTop: 6 }}
            />
            {index === 2 && (
              <span
                aria-hidden="true"
                style={{
                  width: 9,
                  height: 24,
                  lineHeight: "24px",
                  marginLeft: -6,
                  marginRight: -6,
                  display: "inline-block",
                  textAlign: "center",
                  color: "#000000",
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: 400,
                  fontSize: 16,
                }}
              >
                -
              </span>
            )}
          </>
        )}
        isInputNum={true}
        shouldAutoFocus={true}
        inputStyle={inputStyle}
        focusStyle={{ outline: "none", boxShadow: "none" }}
        containerStyle={{
          gap: "10px",
        }}
      />
    </div>
  );
};

export default OTP;
